<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" absolute temporary class="blue darken-3">
    <router-link to="/" tag="span" style="cursor: pointer">
      <v-list-item>
        <v-list-item-content>
          <router-link to="/" tag="span" style="cursor: pointer;">
          <v-img alt="Equator Sun Logo" class="shrink" contain src="@/assets/ban.png" transition="scale-transition" width="120"/>
        </router-link>
        <v-list-item-title class="white--text mt-2">Product Of EquatorSun Ltd</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </router-link>
      <v-divider></v-divider>
      <v-list dense>

        <v-list-item v-for="item in items" :key="item.title" link router :to="item.link">
        <v-list-item-avatar>
          <v-icon left dark>{{item.icon}}</v-icon>
        </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2 blue darken-3 text-left">
          <router-link to="/" tag="span" style="cursor: pointer;">
          <v-img alt="Equator Sun Logo" class="shrink" contain src="@/assets/ban.png" transition="scale-transition" width="120"/>
        </router-link>
        <div class="white--text">Product Of EquatorSun</div>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark  class="topAppBar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-none d-sm-flex d-md-none d-flex d-sm-none"></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <router-link to="/" tag="span" style="cursor: pointer">
        <v-img alt="Equator Sun Logo" class="shrink mr-2" contain src="@/assets/ban.png" transition="scale-transition" width="120"/>
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <v-app-bar-items class="hidden-sm-and-down">
       <v-btn text large v-for="item in items" :key="item.title" router :to="item.link"><v-icon left class="white--text">{{item.icon}}</v-icon>{{ item.title }}</v-btn>
    </v-app-bar-items>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer dark padless>
    <v-card class="flex" flat tile>
      <v-row class="footer pl-6 pr-6">
          <v-col cols="12" sm="12" xs12 class="font-weight-light footLocation">
            <p><v-img alt="EquatorSun" class="shrink mr-2" contain src="@/assets/ban.png" transition="scale-transition" width="120"/></p>
            <hr>
            <v-row>
              <v-col cols="6" sm6 xs6>
               <p class="yellow--text">Location</p>
              <p>Kampala Uganda</p>
              <p>2ND Floor DFCU building Gabba</p>
              <p>Rd. next to American Embassy Nsambya</p>
              <p>equator_sun@yahoo.com</p>
            </v-col>

            <v-col cols="6" sm6 xs6 class="text-right">
              <p class="yellow--text">Services</p>
              <p>SunLine Solar Water Heaters</p>
              <p>Consultancy</p>
            </v-col>
            </v-row>

          </v-col>

      </v-row>

      <v-card-text class="py-2 font-weight-light white--text text-center black">
       Copyright {{ new Date().getFullYear() }} —
      <a :href="developer" tag="span" style="cursor: pointer;text-decoration:none;color:white;">
        <strong>Designed By Mpwanyi Samuel</strong>
      </a>
      </v-card-text>
    </v-card>
  </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {

  },

  data: () => ({//
    items: [ { link: '#', title: '+256 (772) 415642', icon: 'fa-phone-alt' }, { link: '/Quote', title: 'Get A Free Quote', icon: 'fa-file-alt' }, { link: '/Contact', title: 'Contact Us', icon: 'fa-envelope-open-text' } ],
    drawer: null
  }),
  computed: {
    developer () {
      return this.$store.getters.getDeveloper
    }
  }
}
</script>
<style scoped>
  .footer{
    background: #00529f;
    color: white;
  }
  .footLocation{
    padding-left: 15px;
    font-size: 14px;
  }
</style>
